export const PAYMENT_METHODS = [
    {
        id: 'komoju',
        hidden: true,
        provider: 'komoju',
        name: 'KOMOJU',
        description: 'paymentMethod.komojuDescription',
        icon: 'komoju',
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        shadowColor: 'rgba(102, 126, 234, 0.4)'
    },
    {
        id: 'stripe_card',
        provider: 'stripe',
        name: 'Credit / Debit Card',
        description: 'paymentMethod.stripeCardDescription',
        icon: 'creditCard',
        gradient: 'linear-gradient(135deg, #635bff 0%, #00d4ff 100%)',
        shadowColor: 'rgba(99, 91, 255, 0.4)'
    },
    {
        id: 'stripe_apple_pay',
        provider: 'stripe',
        name: 'Apple Pay',
        description: 'paymentMethod.applePayDescription',
        icon: 'applePay',
        gradient: 'linear-gradient(135deg, #1a1a1a 0%, #4a4a4a 100%)',
        shadowColor: 'rgba(0, 0, 0, 0.3)'
    },
    {
        id: 'stripe_google_pay',
        provider: 'stripe',
        name: 'Google Pay',
        description: 'paymentMethod.googlePayDescription',
        icon: 'googlePay',
        gradient: 'linear-gradient(135deg, #4285F4 0%, #34A853 100%)',
        shadowColor: 'rgba(66, 133, 244, 0.4)'
    },
    {
        id: 'stripe_link',
        provider: 'stripe',
        name: 'Link',
        description: 'paymentMethod.linkDescription',
        icon: 'link',
        gradient: 'linear-gradient(135deg, #00D924 0%, #00A51C 100%)',
        shadowColor: 'rgba(0, 217, 36, 0.4)'
    }
];

export const VISIBLE_PAYMENT_METHODS = PAYMENT_METHODS.filter((method) => !method.hidden);
